/**
 * @namespace {BX.UI}
 */
export default class GuideConditionColor
{
	static WARNING = '--condition-warning';
	static ALERT = '--condition-alert';
	static PRIMARY = '--condition-primary';
	static COPILOT = '--condition-copilot';
}
